import ShellApp from './ShellApp';

/** Standalone Vite entry — shell uses ShellApp directly with a locale basePath. */
function App() {
  return <ShellApp basePath={typeof __BASE_PATH__ !== 'undefined' ? __BASE_PATH__ : '/'} />;
}

export default App;
